const MODULE_NAME = 'JobsModule';

export const JOBS_GET_FOLDERS = `${MODULE_NAME}/JOBS_GET_FOLDERS`;
export const JOBS_GET_JOB = `${MODULE_NAME}/JOBS_GET_JOB`;
export const UPDATE_JOB_REPORT = `${MODULE_NAME}/UPDATE_JOB_REPORT`;
export const UPDATE_JOB = `${MODULE_NAME}/UPDATE_JOB`;
export const GET_JOB = `${MODULE_NAME}/GET_JOB`;
export const GET_JOB_PROGRESS = `${MODULE_NAME}/GET_JOB_PROGRESS`;
export const REPAIR_SELECT_REQUEST = `${MODULE_NAME}/REPAIR_SELECT_REQUEST`;
export const GET_JOB_ATTACHMENTS_COUNT = `${MODULE_NAME}/GET_JOB_ATTACHMENTS_COUNT`;

export const ADD_REPAIR_ASSESSMENT_ROW = `${MODULE_NAME}/ADD_REPAIR_ASSESSMENT_ROW`;
export const UPDATE_REPAIR_ASSESSMENT_ROW = `${MODULE_NAME}/UPDATE_REPAIR_ASSESSMENT_ROW`;
export const DELETE_REPAIR_ASSESSMENT_ROW = `${MODULE_NAME}/DELETE_REPAIR_ASSESSMENT_ROW`;
export const LINK_REPAIR_ASSESSMENT_TASKS = `${MODULE_NAME}/LINK_REPAIR_ASSESSMENT_TASKS`;
